<script setup lang="ts">
import PageBar from '../components/PageBar.vue';
import PageTitle from '../components/PageTitle.vue';
import PrinterSetupCard from '../components/PrinterSetupCard.vue';
</script>

<template>
  <PageBar tall back-to="/reglages" back-label="Réglages">
    <PageTitle
      title="Imprimante"
      subtitle="L’agent installé sur le PC relié à l’imprimante · propre à ce poste"
    />
  </PageBar>

  <main
    class="no-scrollbar mx-auto flex min-h-0 w-full max-w-[760px] flex-1 flex-col overflow-y-auto px-4 pt-5 pb-5 sm:px-5"
  >
    <PrinterSetupCard />
  </main>
</template>
